<div class="header" mat-dialog-title>
  <h3>{{ 'coupons.nav.distributionRules' | translate }}</h3>
</div>

<div class="messages">
  <txp-message [type]="messageType.DANGER"
               data-qa-label="LoadingErrorMsg"
               *ngIf="loadingError">
    {{ 'coupons.rules.grid.loadingErrorMsg' | translate }}
  </txp-message>
  <txp-message [type]="messageType.WARNING"
               data-qa-label="EmptySearchList"
               *ngIf="emptySearchList">
    {{ 'coupons.rules.grid.emptySearchListMsg' | translate }}
  </txp-message>
<txp-message [type]="messageType.WARNING"
             data-qa-label="EmptyRulesList"
             *ngIf="emptyRulesList">
    {{ 'coupons.rules.grid.emptyRulesListMsg' | translate }}
</txp-message>
</div>

<div class="header">
  <div class="header-actions">
    <div class="search-filter-container">
      <mat-form-field class="search-input">
        <i matPrefix class="tce-icon-search"></i>
        <input matInput
               (keyup)="filter($event.target.value)"
               [placeholder]="'coupons.rules.grid.search' | translate"/>
      </mat-form-field>
    </div>
    <txp-button [hidden]="rulesReadOnly"
                data-qa-label="CreateRuleButton"
                [style]="buttonStyle.PRIMARY"
                [size]="buttonSize.SMALL"
               (click)="createRule()">
        {{ 'coupons.rules.grid.createRuleBtn' | translate }}
    </txp-button>
  </div>
</div>

<txp-loading [color]="loadingColor.COLOR" *ngIf="isLoading"></txp-loading>

<div class="table-content" [hidden]="isLoading">
  <table mat-table
         [dataSource]="dataSource"
         matSort
         (matSortChange)="onSortChange($event)"
         matSortActive="name"
         matSortDirection="desc"
         matSortDisableClear
         [hidden]="isLoading"
         class="rules-list">
    <ng-container matColumnDef="select">
      <th mat-header-cell *matHeaderCellDef>
        <mat-checkbox (change)="$event ? masterToggle() : null"
                      [checked]="selection.hasValue() && isAllSelected()"
                      [indeterminate]="selection.hasValue() && !isAllSelected()"
                      data-qa-label="MasterToggleCheckBox">
        </mat-checkbox>
      </th>
      <td mat-cell *matCellDef="let row">
        <mat-checkbox (click)="$event.stopPropagation()"
                      (change)="$event ? selection.toggle(row) : null"
                      [checked]="selection.isSelected(row)"
                      data-qa-label="MenuRowCheckBox">
        </mat-checkbox>
      </td>
    </ng-container>

    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.name' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        <a class="edit-link"
           (click)="editRule(rule)"
           [attr.title]="'form.button.edit' | translate"
           data-qa-label="EditLink"
           href="javascript:void(0);">
          {{ rule.name }}
        </a>
      </td>
    </ng-container>

    <ng-container matColumnDef="type">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.type' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ typeMap[rule.type] | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="audience">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.audience' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ audienceMap[rule.audience] | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="enabled">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.enabled' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ enabledMap[rule.enabled] | translate }}
      </td>
    </ng-container>

    <ng-container matColumnDef="schedule.startDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.start' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ rule.schedule ? (rule.schedule.startDate | date: 'yyyy/MM/dd') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="schedule.endDate">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.end' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ rule.schedule ? (rule.schedule.endDate | date: 'yyyy/MM/dd') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="schedule.frequency">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.period' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ rule.schedule ? ((frequencyMap[rule.schedule?.frequency] | translate) + ' (' + rule.schedule?.frequencyModifier + ')') : '-' }}
      </td>
    </ng-container>

    <ng-container matColumnDef="createdOn">
      <th mat-header-cell *matHeaderCellDef mat-sort-header>
        {{ 'coupons.rules.grid.createdOn' | translate }}
      </th>
      <td mat-cell *matCellDef="let rule">
        {{ rule.createdOn | date: 'yyyy/MM/dd' }}
      </td>
    </ng-container>

    <!-- footer for "still loading" message -->
    <ng-container matColumnDef="loading">
      <td mat-footer-cell *matFooterCellDef colspan="100">
        <div>
          <txp-loading [type]="loadingType.INLINE" [color]="loadingColor.COLOR"></txp-loading>
          {{ 'rule.grid.loading' | translate }}
        </div>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayColumns; sticky: true"></tr>
    <tr mat-row *matRowDef="let row; columns: displayColumns"></tr>
    <tr mat-footer-row
        *matFooterRowDef="['loading']; sticky: true"
        [hidden]="!isLoading || page === 0"
    ></tr>
  </table>
  <div class="show-more">
    <txp-button (click)="loadMoreRules()"
                [disabled]="isLoading || isLastPage"
                [loading]="loadingMore"
                [size]="buttonSize.SMALL"
                [style]="buttonStyle.NOBACKGROUND">
       {{ 'coupons.rules.grid.showMore' | translate }}
    </txp-button>
  </div>
</div>
